import { BaseRequest } from '@/network/requests/BaseRequest'
import { access_log } from '@/interfaces/access_log'

export const accessLogRequest = BaseRequest.build<access_log>('access_log')
